/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, { useState, useCallback } from 'react';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../redux/helper/CreateQuery';

function BulkOrdersFilterModal({
    filterModal, setFilterModal, selected, setselected, Filter, setFilter, handleFilter, SetSuccessMessage, handleFetchBulkOrders, setfilterValue,
}) {
    const [selectedType, setselectedType] = useState('type');
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'type':
                if (Filter[key].length > 0) {
                    final += `&industrial_pocket=${createUrl(Filter[key])}`;
                }
                break;

            default: break;
            }
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&created_at=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        return final;
    };

    const handleClear = () => {
        setFilter({
            type: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        handleFetchBulkOrders();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state);
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? '' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[573px] min-w-[573px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[50%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('type')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base font-semibold text-[#AAA6AF] order relative w-full ${selectedType === 'type' ? 'active' : ''}`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('date_range')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block text-base font-semibold text-[#AAA6AF] order ${selectedType === 'date_range' ? 'active' : ''} relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilltype"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Date Range
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[230px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'type' ? 'show active' : ''} fade px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="relative flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('ALL') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('ALL')}
                                                onChange={() => HandleFilter('type', 'ALL')}
                                                borderColor={`${Filter.type?.includes('ALL') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn17"
                                            />
                                            <label htmlFor="mn1" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">All</label>
                                        </div>
                                        <div className="relative flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('HIP') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('HIP')}
                                                onChange={() => HandleFilter('type', 'HIP')}
                                                borderColor={`${Filter.type?.includes('HIP') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn18"
                                            />
                                            <label htmlFor="mn2" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">HIP</label>
                                        </div>
                                        <div className="relative flex items-center mb-3">
                                            <Checkbox
                                                icon={
                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('MIP') ? '#555259' : ''}` }} />
                                                }
                                                name="my-input"
                                                className="cursor-pointer"
                                                checked={Filter.type?.includes('MIP')}
                                                onChange={() => HandleFilter('type', 'MIP')}
                                                borderColor={`${Filter.type?.includes('MIP') ? '#B8C5DC' : '#555259'}`}
                                                style={{ cursor: 'pointer' }}
                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                id="mn19"
                                            />
                                            <label htmlFor="mn3" className="consumbales pl-3 text-xs9 font-normal text-[#000000] text-left cursor-pointer">MIP</label>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selectedType === 'date_range' ? 'show active' : ''}  w-full px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                />
                                            </div>
                                            {toggle.start_date && (
                                                <Calendar
                                                    value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                                    onChange={(val) => handleDate(val, 'start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && <Calendar value={selected.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[50%] mr-5">
                                <button
                                    onClick={() => handleClear()}
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    onClick={() => generateUrl()}
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BulkOrdersFilterModal;
